<script lang="ts">
	import { onDestroy } from 'svelte';
	//Formating
	import { format } from 'svelte-i18n';
	import { Button, Modal } from '@Shelly/shelly-design-system';
	//Helpers
	import SetUpWeatherLocation from './SetUpWeatherLocation.svelte';
	import { addWeatherStation } from 'src/helpers/geolocalion_helper';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Types
	import type {
		RegWeatherServiceResponse,
		WeatherStationSaveData,
	} from '../../types/requests/services/weather';
	import { postReq } from 'src/services/http';
	import { save_profile } from 'src/helpers/profile_helpers';

	export let showModal = false;

	let weatherStationSaveData: WeatherStationSaveData;
	let waitForSaveResponse = false;
	let waitForCacheTimeoutID: NodeJS.Timeout;
	let tempUnit;

	const saveStation = async () => {
		waitForSaveResponse = true;
		clearTimeout(waitForCacheTimeoutID);

		if (tempUnit) {
			const resTemp = await postReq('/user/set_account_units', {
				set: 'temp_unit',
				val: tempUnit,
			});
			if (resTemp.isok) {
				save_profile('weather_temp_unit', tempUnit);
				if (!weatherStationSaveData) {
					onSettingsResponse(resTemp);
					showModal = false;
				}
			}
		}

		if (weatherStationSaveData) {
			const res: RegWeatherServiceResponse = await addWeatherStation(weatherStationSaveData);
			if (res?.isok && res.data?.old == false) {
				waitForCacheTimeoutID = setTimeout(saveStation, 1500);
			} else {
				onSettingsResponse(res);
				waitForSaveResponse = false;
				if (res?.isok) showModal = false;
			}
		}
	};

	onDestroy(() => {
		clearTimeout(waitForCacheTimeoutID);
	});
</script>

<Modal
	on:close={() => (showModal = false)}
	{showModal}
	title={$format('title_edit_weather_settings', {
		default: 'Edit Weather Settings',
	})}
	backdropClose
>
	<SetUpWeatherLocation
		bind:weatherStationSaveData
		slot="content"
		on:set-temp-unit={(e) => (tempUnit = e.detail.tempUnit)}
	/>

	<div slot="footer" class="d-flex justify-content-end">
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			variant="secondary"
			on:click={() => (showModal = false)}
		>
			{$format('button_cancel', { default: 'Cancel' })}
		</Button>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			responsiveSize={{
				sm: 'm',
			}}
			loading={waitForSaveResponse}
			disabled={(!tempUnit && !weatherStationSaveData) || waitForSaveResponse}
			on:click={saveStation}
		>
			{$format('button_save', { default: 'Save' })}
		</Button>
	</div>
</Modal>
